var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card-compare__label"
  }, [!_vm.attrib.label ? _c('div') : _c('div', {
    staticClass: "card-compare__label__container"
  }, [_c('span', {
    staticClass: "card-compare__label__text"
  }, [_c('b-avatar', {
    staticClass: "p-0 align-self-start",
    attrs: {
      "variant": "white",
      "square": ""
    }
  }, [_vm._t("default", [_vm.attrib.img ? _c('div', [_c('b-img', {
    attrs: {
      "src": _vm.imgPath + _vm.attrib.img,
      "fluid": ""
    }
  })], 1) : _c('div', [_c('font-awesome-icon', {
    staticClass: "text-dark",
    attrs: {
      "icon": _vm.attrib.icon ? _vm.attrib.icon : 'question'
    }
  })], 1)])], 2), _vm._v(" " + _vm._s(_vm.attrib.label) + " ")], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }